import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  voiceTitle: {
    id: 'donater.form.voice.title',
    defaultMessage: 'Voice',
  },
  voicePlaceholder: {
    id: 'donater.form.voice.placeholder',
    defaultMessage: 'Select voice',
  },
})
